import React, { Fragment, useState, useEffect, useContext } from "react";
import { Redirect } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import { UrlServicesContext } from "../components/UrlServicesContext";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import {
  AccountBalance,
  PhotoCamera,
  Assignment,
  AddCircle,
  Place,
} from "@material-ui/icons/";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import Slide from "@material-ui/core/Slide";
import FormLabel from "@material-ui/core/FormLabel";
import Container from "@material-ui/core/Container";
import axios from "axios";
import MapDraggableRegistroWeb from "./maps/MapDraggableRegistroWeb";
import DateFnsUtils from "@date-io/date-fns";
import format from "date-fns/format";
import deLocale from "date-fns/locale/es";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";

import LoadCiudades from "../components/services/LoadCiudades";
import LoadCategoria from "../components/services/LoadCategoria";
import LoadEntregaProductos from "../components/services/LoadEntregaProductos";

const useStyles = makeStyles((theme) => ({
  icon: {
    fontSize: "24px",
    color: "#000",
    verticalAlign: "middle",
  },
  dividerBottom: {
    marginBottom: "2%",
  },
  imgUser: {
    width: "150px",
    height: "150px",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    objectFit: "cover",
    borderRadius: "50%",
    boxShadow:
      " 0 4px 20px 0 rgba(0, 0, 0,.14), 0 7px 10px -5px rgba(76, 175, 80,.4)",
  },
  containerImg: {
    width: "100%",
    borderTopLeftRadius: "20px",
    borderTopRightRadius: "20px",
  },
  input: {
    display: "none",
  },
  buttonSubmit: {
    fontFamily: '"Yanone Kaffeesatz", Sans-serif',
    letterSpacing: "1.5px",
    fontWeight: "600",
    marginTop: "6%",
    color: "#000",
    background: "#F7F00B",
    boxShadow:
      "0 4px 20px 0 rgba(0, 0, 0,.14), 0 7px 10px -5px rgba(0, 0, 0,.4)",
    "&:hover": {
      backgroundColor: "#000",
      color: "#F7F00B",
    },
  },
  container: {
    padding: "2%",
    borderRadius: "20px",
  },
  iconImgUser: {
    backgroundColor: "#F2F2F2",
    top: "-25px",
  },
  textBotom: {
    padding: "5px",
    fontFamily: '"Yanone Kaffeesatz", Sans-serif',
    letterSpacing: "1.5px",
    fontWeight: "600",
    textDecoration: "none",
    color: "#000",
  },
}));

export default function Miregistros(props) {
  const classes = useStyles();
  const [alert] = useState({
    loggedIn: localStorage.getItem("token") === null ? false : true,
  });

  const [avatar, setAvatar] = useState("unnamed.png");
  const [success, setSuccess] = useState(false);
  const [openBackdrop, setoOpenBackdrop] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [mensaje_error, setMensaje_error] = useState("");
  const [mensaje_success, setMensaje_success] = useState("");
  const [openAlertsuccess, setOpenAlertsuccess] = useState(false);
  const [imgNew, setImgNew] = useState("");
  const [loader, setLoader] = useState(true);
  const [loaderImg, setLoaderImg] = useState(false);
  const [imgAvatar, setImgAvatar] = useState("");
  const [avatarType, setAvatarType] = useState("");

  const { urlServices, urlImgServices } = useContext(UrlServicesContext);

  const [values, setValues] = useState({
    nombres: "",
    apellidos: "",
    cedula: "",
    email: "",
    telefono: "",
    nombreNegocio: "",
    fechaInicio: null,
    direccionNegocio: "",
    descripcionNegocio: "",
    entregaDomicilio: "",
    clave: "",
    linkPage: "",
    estado: "",
    latitude: 0,
    longitude: 0,
    ciudad: "",
    categoria: "",
    entregaProductos: "",
    error: false,
  });

  const [errorFieldNombres, setErrorFieldNombres] = useState(false);
  const [errorFieldApellidos, setErrorFieldApellidos] = useState(false);
  const [errorFieldCedula, setErrorFieldCedula] = useState(false);
  const [errorFieldEmail, setErrorFieldEmail] = useState(false);
  const [errorFieldNombreNegocio, setErrorFieldNombreNegocio] = useState(false);
  const [errorFieldTelefono, setErrorFieldTelefono] = useState(false);
  const [errorFieldCiudad, setErrorFieldCiudad] = useState(false);
  const [errorFieldDireccionNegocio, setErrorFieldDireccionNegocio] = useState(
    false
  );
  const [
    errorFieldDescripcionNegocio,
    setErrorFieldDescripcionNegocio,
  ] = useState(false);
  const [errorFieldFechaInicio, setErrorFieldErrorFieldFechaInicio] = useState(
    false
  );

  useEffect(() => {
    const data = new FormData();
    data.append("id", localStorage.getItem("user_id"));

    const consultarRegistroWeb = async () => {
      await axios
        .post(urlServices + "routes.php?servicio=consultarRegistroWeb", data)
        .then(
          (response) => {
            if (response.data.code === 0) {
              if (
                response.data.result.avatar === "" ||
                response.data.result.avatar === null
              ) {
                setImgAvatar(
                  "../../images/unnamed.png?v=" + response.data.random + ""
                );
              } else {
                setImgAvatar(
                  urlImgServices +
                    "/" +
                    response.data.result.avatar +
                    "?v=" +
                    response.data.random
                );
              }

              setValues({
                ...values,
                nombres: response.data.result.nombres,
                apellidos: response.data.result.apellidos,
                cedula: response.data.result.cedulaPropietario,
                telefono: response.data.result.telefono,
                email: response.data.result.email,
                clave: response.data.result.clave,
                direccionNegocio: response.data.result.direccion,
                descripcionNegocio: response.data.result.descripcion,
                fechaInicio: new Date(
                  response.data.result.fechaInicioTienda + "T21:11:54"
                ),
                entregaDomicilio: response.data.result.entregaDomicilio,
                linkPage: response.data.result.link_page,
                estado: response.data.result.estado,
                nombreNegocio: response.data.result.nombreNegocio,
                ciudad: response.data.result.ciudad,
                categoria: response.data.result.categoria,
                entregaProductos: response.data.result.entregaProductos,
              });

              setLoader(false);
            }
          },
          (error) => {
            setLoader(false);
            setValues({
              ...values,
              isLoadedPublicoObjetivo: true,
              error: true,
            });
          }
        );
    };

    consultarRegistroWeb();
  }, []);

  const submitForm = (e) => {
    e.preventDefault();

    setValues({ ...values, error: false });
    setSuccess(false);

    if (values.nombres.length === 0) {
      setErrorFieldNombres(true);
      setMensaje_error('El campo "Nombres" es obligatorio!');
      setOpenAlert(true);
      setoOpenBackdrop(false);
    } else if (values.apellidos.length === 0) {
      setErrorFieldApellidos(true);
      setMensaje_error('El campo "Apellidos" es obligatorio!');
      setOpenAlert(true);
      setoOpenBackdrop(false);
    } else if (values.cedula.length === 0) {
      setErrorFieldCedula(true);
      setMensaje_error('El campo "Cédula" es obligatorio!');
      setOpenAlert(true);
      setoOpenBackdrop(false);
    } else {
      setoOpenBackdrop(true);

      const data = new FormData();
      data.append("id", localStorage.getItem("user_id"));
      data.append("nombres", values.nombres);
      data.append("apellidos", values.apellidos);
      data.append("cedula", values.cedula);
      data.append("email", values.email);
      data.append("nombreNegocio", values.nombreNegocio);
      data.append("telefono", values.telefono);
      data.append("ciudad", JSON.stringify(values.ciudad));
      data.append("categoria", JSON.stringify(values.categoria));
      data.append("entregaProductos", JSON.stringify(values.entregaProductos));
      data.append("fechaInicio", format(values.fechaInicio, "yyyy/MM/dd"));
      data.append("direccionNegocio", values.direccionNegocio);
      data.append("descripcionNegocio", values.descripcionNegocio);

      if (values.longitude !== 0 && values.latitude !== 0) {
        data.append("latitude", values.latitude);
        data.append("longitude", values.longitude);
      } else {
        data.append("latitude", localStorage.getItem("latitude"));
        data.append("longitude", localStorage.getItem("longitude"));
      }

      axios.post(urlServices + "routes.php?servicio=modRegistroWeb", data).then(
        (response) => {
          if (response.data.code === 0) {
            setSuccess(true);
            setoOpenBackdrop(false);

            localStorage.setItem("latitude", response.data.latitude);
            localStorage.setItem("longitude", response.data.longitude);

            let user = [
              { img: "" },
              { name: response.data.nombres },
              { random: "" },
            ];
            props.changeUserImg(user);
          } else {
            console.log(response);
            setValues({ ...values, error: true });
            setoOpenBackdrop(false);
          }
        },
        (error) => {
          console.log(error);
          setoOpenBackdrop(false);
        }
      );
    }
  };

  const cambiarFoto = (e) => {
    setImgNew("");
    setLoaderImg(true);

    e.preventDefault();

    const sentFoto = (data) => {
      axios.post(urlServices + "routes.php?servicio=modFoto", data).then(
        (response) => {
          if (response.data.code === 0) {
            setTimeout(() => {
              setLoaderImg(false);
              setOpenAlertsuccess(true);
              setMensaje_success("Imagen cambiada con exito.");
              if (
                response.data.avatar === "" ||
                response.data.avatar === null
              ) {
                setImgAvatar(
                  "../../images/unnamed.png?v=" + response.data.random + ""
                );
                let user = [
                  { img: imgAvatar },
                  { name: "" },
                  { random: response.data.random },
                ];
                props.changeUserImg(user);
              } else {
                setImgAvatar(
                  urlImgServices +
                    response.data.avatar +
                    "?v=" +
                    response.data.random
                );
                let user = [
                  { img: urlImgServices + response.data.avatar },
                  { name: "" },
                  { random: response.data.random },
                ];
                props.changeUserImg(user);
              }
            }, 1500);
          } else {
            console.log(response);
            setValues({ ...values, error: true });
            setLoaderImg(false);
          }
        },
        (error) => {
          console.log(error);
        }
      );
    };

    if (avatar !== "unnamed.png") {
      const reader = new FileReader();
      reader.readAsDataURL(avatar);

      reader.onload = (e) => {
        const data = new FormData();
        data.append("id", localStorage.getItem("user_id"));
        data.append("avatar", e.target.result);
        data.append("avatarType", avatarType);

        sentFoto(data);
      };
    }
  };

  const setAvatarValue = (e) => {
    if (e.target.files.length !== 0) {
      setAvatarType(e.target.files[0].type);
      setAvatar(e.target.files[0]);
      setImgNew("Imagen seleccionada: " + e.target.files[0].name);
    }
  };

  const getResponseCiudad = (pro) => {
    setValues({ ...values, ciudad: pro });
  };

  const getResponseCategoria = (pro) => {
    setValues({ ...values, categoria: pro });
  };

  const getResponseEntregaProductos = (pro) => {
    setValues({ ...values, entregaProductos: pro });
  };

  const handleChangeFechaInicio = (date) => {
    setValues({ ...values, fechaInicio: date });
  };

  const getResponselt = (latitude) => {
    setValues({ ...values, latitude: latitude });
  };

  const getResponselng = (longitude) => {
    setValues({ ...values, longitude: longitude });
  };

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenAlertsuccess(false);
  };

  if (!alert.loggedIn) {
    return <Redirect to="/" />;
  }

  if (loader) {
    return (
      <Fragment>
        <CircularProgress />
      </Fragment>
    );
  } else {
    return (
      <Fragment>
        <Typography
          align="left"
          variant="subtitle1"
          className={classes.textBotom}
        >
          <AccountBalance className={classes.icon} /> Registro
        </Typography>
        <Divider className={classes.dividerBottom} />

        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} className={classes.containerImg}>
              <center>
                <Typography align="center" variant="h6">
                  Logo
                </Typography>
                <br></br>
                <img src={imgAvatar} alt="avatar" className={classes.imgUser} />
                <input
                  accept="image/*"
                  className={classes.input}
                  id="icon-button-file"
                  type="file"
                  onChange={setAvatarValue}
                />
                <br></br>
                <label htmlFor="icon-button-file">
                  <IconButton
                    color="secondary"
                    aria-label="upload picture"
                    component="span"
                    className={classes.iconImgUser}
                  >
                    <PhotoCamera />
                  </IconButton>
                </label>
                <Typography align="center" variant="subtitle2">
                  {imgNew !== "" ? (
                    <div>
                      {imgNew} <br></br>{" "}
                      <Button
                        onClick={cambiarFoto}
                        variant="contained"
                        size="small"
                      >
                        Cambiar
                      </Button>
                    </div>
                  ) : loaderImg ? (
                    <img
                      src="../../images/loading.gif"
                      alt="loadin"
                      width="45"
                    />
                  ) : (
                    ""
                  )}
                </Typography>
              </center>
            </Grid>
          </Grid>

          <Typography color="error" variant="body2" align="right">
            <b>* Obligatorio</b>
          </Typography>
          <Typography
            variant="subtitle2"
            gutterBottom
            className={classes.textBotom}
          >
            <Assignment className={classes.icon} />
            &nbsp;DATOS PERSONALES DEL PROPIETARIO
          </Typography>
          <Divider variant="fullWidth" style={{ marginBottom: "4%" }} />

          <Grid
            container
            spacing={3}
            style={{
              paddingTop: "2%",
              paddingRight: "3%",
              paddingLeft: "3%",
            }}
          >
            <Grid item xs={12} sm={6}>
              <TextField
                name="nombres"
                value={values.nombres}
                error={errorFieldNombres}
                onChange={handleChange("nombres")}
                fullWidth
                required
                inputProps={{ maxLength: 100 }}
                label="Nombres"
                //helperText="Error"
                margin="dense"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                error={errorFieldApellidos}
                name="apellidos"
                value={values.apellidos}
                onChange={handleChange("apellidos")}
                fullWidth
                required
                inputProps={{ maxLength: 100 }}
                label="Apellidos"
                //helperText="Error"
                margin="dense"
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                error={errorFieldCedula}
                name="cedula"
                value={values.cedula}
                onChange={handleChange("cedula")}
                fullWidth
                required
                inputProps={{ maxLength: 15 }}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[^0-9]/g, "");
                }}
                label="Cédula"
                margin="dense"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                error={errorFieldEmail}
                name="email"
                value={values.email}
                onChange={handleChange("email")}
                fullWidth
                required
                disabled
                inputProps={{ maxLength: 50, readOnly: true }}
                label="Correo electrónico"
                margin="dense"
              />
            </Grid>

            <Grid item xs={12} sm={6} style={{ marginTop: "1%" }}>
              <LoadCiudades
                callbackCiudad={getResponseCiudad}
                valueCiudad={{ text: values.ciudad.text, id: values.ciudad.id }}
              />

              <Typography variant="subtitle2" color="error">
                {errorFieldCiudad}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} style={{ marginTop: "1%" }}>
              <TextField
                error={errorFieldTelefono}
                name="telefono"
                value={values.telefono}
                onChange={handleChange("telefono")}
                fullWidth
                required
                inputProps={{ maxLength: 20 }}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[^0-9]/g, "");
                }}
                label="Teléfono donde los clientes puedan llamar"
                margin="dense"
              />
            </Grid>

            <Grid item xs={12} sm={12} style={{ marginTop: "5%" }}>
              <Typography
                variant="subtitle2"
                gutterBottom
                className={classes.textBotom}
              >
                <AddCircle className={classes.icon} />
                &nbsp;INFORMACIÓN DEL NEGOCIO
              </Typography>
              <Divider variant="fullWidth" style={{ marginBottom: "4%" }} />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                name="nombreNegocio"
                value={values.nombreNegocio}
                error={errorFieldNombreNegocio}
                onChange={handleChange("nombreNegocio")}
                fullWidth
                required
                inputProps={{ maxLength: 30 }}
                label="Nombre del negocio"
                //helperText="Error"
                margin="dense"
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormLabel
                required
                component="legend"
                error={errorFieldFechaInicio}
              >
                Fecha de inicio del negocio
              </FormLabel>
              <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
                <KeyboardDatePicker
                  // disableToolbar
                  //  disabled={disabled}
                  // error={errorField.fechaFin}
                  variant="inline"
                  format="dd/MM/yyyy"
                  margin="normal"
                  // openTo="year"
                  autoOk={true}
                  id="fechaInicio"
                  //label="Fecha Fin"
                  value={values.fechaInicio}
                  onChange={handleChangeFechaInicio}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  style={{ width: "100%" }}
                />
              </MuiPickersUtilsProvider>
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                rows="2"
                error={errorFieldDireccionNegocio}
                name="direccionNegocio"
                value={values.direccionNegocio}
                onChange={handleChange("direccionNegocio")}
                fullWidth
                label="Dirección del negocio"
                required
                inputProps={{ maxLength: 100 }}
                multiline
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                rows="2"
                error={errorFieldDescripcionNegocio}
                name="descripcionNegocio"
                value={values.descripcionNegocio}
                onChange={handleChange("descripcionNegocio")}
                fullWidth
                label="Describa a que se dedica su negocio"
                required
                inputProps={{ maxLength: 50 }}
                multiline
              />
            </Grid>

            <Grid item xs={12} sm={6} style={{ marginTop: "1%" }}>
              <LoadCategoria
                callbackCategoria={getResponseCategoria}
                valueCategoria={{
                  text: values.categoria.text,
                  id: values.categoria.id,
                }}
              />

              <Typography variant="subtitle2" color="error">
                {/*errorFieldCategoria*/}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} style={{ marginTop: "1%" }}>
              <LoadEntregaProductos
                callbackEntregaProductos={getResponseEntregaProductos}
                valueEntregaProductos={{
                  text: values.entregaProductos.text,
                  id: values.entregaProductos.id,
                }}
              />

              <Typography variant="subtitle2" color="error"></Typography>
            </Grid>

            <Grid item xs={12} sm={12} style={{ marginTop: "5%" }}>
              <Typography
                variant="subtitle2"
                gutterBottom
                className={classes.textBotom}
              >
                <Place className={classes.icon} />
                &nbsp;UBICACIÓN
              </Typography>
              <Divider variant="fullWidth" style={{ marginBottom: "4%" }} />
            </Grid>

            <Grid
              style={{
                position: "relative",
                height: "300px",
                flexWrap: "inherit",
                width: "100%",
              }}
            >
              <FormLabel component="legend">
                Por favor, arrastre el puntero si desea editar la ubicación del
                negocio.
              </FormLabel>
              <br></br>
              <MapDraggableRegistroWeb
                callbacklt={getResponselt}
                callbacklng={getResponselng}
              />
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} style={{ marginTop: "10%" }}>
            <Divider variant="fullWidth" />
            {values.error ? (
              <Alert severity="error">Error en el registro!</Alert>
            ) : (
              ""
            )}
            {success ? (
              <Alert severity="success">Datos modificados con exito!</Alert>
            ) : (
              ""
            )}
          </Grid>

          <Grid item xs={12} sm={12}>
            <center>
              <Button
                onClick={submitForm}
                variant="contained"
                size="large"
                className={classes.buttonSubmit}
              >
                Guardar
              </Button>
            </center>
          </Grid>
        </Container>

        <Backdrop
          style={{ zIndex: "9999", color: "#FFFFFF" }}
          open={openBackdrop}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Snackbar
          open={openAlert}
          autoHideDuration={6000}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          onClose={handleClose}
        >
          <Slide direction="up" in={openAlert} mountOnEnter unmountOnExit>
            <Alert
              onClose={handleClose}
              severity="error"
              elevation={6}
              variant="filled"
            >
              {mensaje_error}
            </Alert>
          </Slide>
        </Snackbar>

        <Snackbar
          open={openAlertsuccess}
          autoHideDuration={5000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={handleClose}
        >
          <Slide
            direction="up"
            in={openAlertsuccess}
            mountOnEnter
            unmountOnExit
          >
            <Alert
              onClose={handleClose}
              severity="success"
              elevation={6}
              variant="filled"
            >
              {mensaje_success}
            </Alert>
          </Slide>
        </Snackbar>
      </Fragment>
    );
  }
}
